import React from 'react';
import { withStyles, Grid, Card, CardContent } from '@material-ui/core';
import { ToggleUI } from '../../common';
import { useHistory } from 'react-router-dom';
import { createAmplitudeEventWithDevice } from '../../amplitude';
import IconStepCompleted from './IconStepCompleted';

const OnboardingCard_ = ({ classes, onboarding_card }) => {
  let history = useHistory();

  const container_style = (onboarding_card, classes) => {
    switch (onboarding_card.step_state) {
      case 'done':
        return classes.card_done;
      case 'prev_step_not_done':
        return classes.card_ready;
      default:
        return classes.card_ready;
    }
  };

  const color_icon = (step_state) => {
    switch (step_state) {
      case 'done':
        return '#53B755';
      case 'prev_step_not_done':
        return '#383838';
      default:
        return '#383838';
    }
  };

  const logo_step = (logo, step_state) => {
    const svg = {
      ...logo,
      props: {
        ...logo.props,
        children: {
          ...logo.props.children,
          props: {
            ...logo.props.children.props,
            fill: color_icon(step_state),
          },
        },
      },
    };

    return svg;
  };

  return (
    <Grid
      item
      md
      xs={12}
      onClick={() => {
        createAmplitudeEventWithDevice(onboarding_card.amplitude_event);
        history.push(onboarding_card.link_to);
      }}
    >
      <Card
        className={`${classes.container} ${container_style(
          onboarding_card,
          classes
        )}`}
      >
        <CardContent
          classes={{
            root: classes.card_content,
          }}
        >
          <div className={classes.container_icons}>
            <div>
              {logo_step(onboarding_card.image, onboarding_card.step_state)}
            </div>
            <div>
              <ToggleUI show={onboarding_card.step_state === 'done'}>
                <span>
                  <IconStepCompleted />
                </span>
              </ToggleUI>
            </div>
          </div>
          <div className={classes.container_text}>
            <p className={classes.card_text}>{onboarding_card.title}</p>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
};

const card_ready = {
  color: '#383838',
  border: '1px solid #A5A5A5',
  '&:hover': {
    cursor: 'pointer',
  },
};

const card_prev = {
  opacity: '0.5',
  color: '#383838',
  border: '1px solid #A5A5A5',
  //Para mobile
  touchAction: 'none',
  //Para browser
  pointerEvents: 'none',
};

const card_done = {
  color: '#53B755',
  border: '1px solid #53B755',
  '&:hover': {
    cursor: 'pointer',
  },
};

const styles = (theme) => ({
  container: {
    maxHeight: '120px',
    borderRadius: '6px',
    margin: '0px 24px 0px 0px',
    padding: '15px !important',
    [theme.breakpoints.down('sm')]: {
      margin: '24px 0px 0px 0px',
      padding: '24px !important',
    },
  },
  container_icons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  container_text: {
    display: 'flex',
  },
  card_text: {
    fontSize: '1rem',
    fontWeight: '500',
    lineHeight: '19px',
  },
  card_ready,
  card_prev,
  card_done,
});

export const OnboardingCard = withStyles(styles)(OnboardingCard_);
